import { c as _c } from "react/compiler-runtime";
import type { ComparisonTableColumn } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { isAmexOffer } from '@cc-shopping/utils/offers';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import ApprovalOdds from 'src/features/approval-odds';
import { MAXIMUM_COLUMNS_MOBILE } from '../Context';
type ComparisonTableFooterProps = {
  column: ComparisonTableColumn;
  columnIndex: number;
};
export default function ComparisonTableFooter(t0) {
  const $ = _c(23);
  const {
    column,
    columnIndex
  } = t0;
  const {
    isPrimaryEntity,
    marketplaceEntity
  } = column;
  let t1;
  if ($[0] !== marketplaceEntity) {
    t1 = isAmexOffer(marketplaceEntity);
    $[0] = marketplaceEntity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isAmexCard = t1;
  const t2 = isPrimaryEntity ? 5 : 0;
  const t3 = isPrimaryEntity ? "2" : "1";
  const t4 = `footer-container-${columnIndex}`;
  const t5 = columnIndex > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t6;
  if ($[2] !== t5) {
    t6 = {
      md: "flex",
      xs: t5
    };
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = columnIndex === 0 ? "1px solid" : 0;
  let t8;
  if ($[4] !== t7) {
    t8 = {
      borderBottom: "1px solid",
      borderRight: "1px solid",
      borderLeft: t7,
      borderColor: "neutral.light",
      backgroundColor: "neutral.lightest",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center"
    };
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = isAmexCard ? "RECOMMENDED CREDIT" : "RECOMMENDED CREDIT SCORE";
  let t10;
  if ($[6] !== t9) {
    t10 = <Typography variant="textSmallBold" fontWeight="bold" lineHeight={1.5} marginBottom={1} marginTop={1} letterSpacing=".0625em">{t9}</Typography>;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== marketplaceEntity.maxFico || $[9] !== marketplaceEntity.minFico) {
    t11 = {
      min: marketplaceEntity.minFico,
      max: marketplaceEntity.maxFico
    };
    $[8] = marketplaceEntity.maxFico;
    $[9] = marketplaceEntity.minFico;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== isAmexCard || $[12] !== marketplaceEntity.limitedCreditHistory || $[13] !== t11) {
    t12 = <ApprovalOdds odds={t11} hasLimitedCreditHistory={marketplaceEntity.limitedCreditHistory} smallApprovalLabelText={true} smallScoreRangeText={true} graphContent={true} hideOddsButton={true} hideOddsButtonArrow={false} type="reviews" isAmexOffer={isAmexCard} />;
    $[11] = isAmexCard;
    $[12] = marketplaceEntity.limitedCreditHistory;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t12 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t6 || $[21] !== t8) {
    t13 = <Grid boxShadow={t2} zIndex={t3} flexDirection="column" data-testid={t4} display={t6} sx={t8} size={12}>{t10}{t12}</Grid>;
    $[15] = t10;
    $[16] = t12;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}